/*
 * Quick add from a product card.
 *
 * The `+` on an hf-card used to be a decorative span inside the card's link:
 * it read as an add-to-cart button and behaved as navigation. It is now a real
 * button, and snippets/hf-card.liquid only renders it where a single POST can
 * finish the job — one variant, in stock, purchasable online. Everything else
 * (a variant to pick, `coming-soon`, `in-store-only`) gets no button at all,
 * so there is no disabled state to handle here.
 *
 * Delegated off `document` rather than wrapped in a custom element, because
 * cards arrive from the Section Rendering API on facet, paginate and search,
 * and a delegated listener needs no re-wiring when they do.
 */
(function () {
  var RESET_MS = 2000;

  function cartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setState(button, state) {
    button.classList.remove('is-loading', 'is-done', 'is-error');
    if (state) button.classList.add(state);
  }

  /* The live region is a sibling of the button inside .row — the button's own
     aria-label never changes, so screen readers get the outcome from here. */
  function announce(button, message) {
    var live = button.parentElement && button.parentElement.querySelector('[data-quick-add-status]');
    if (live) live.textContent = message;
  }

  function reset(button) {
    window.setTimeout(function () {
      setState(button, null);
      button.removeAttribute('aria-disabled');
    }, RESET_MS);
  }

  function add(button) {
    var variantId = button.dataset.variantId;
    if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

    var cart = cartElement();
    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart) {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);
      // So focus lands back on the button when the drawer closes.
      cart.setActiveElement(button);
    }
    config.body = body;

    button.setAttribute('aria-disabled', 'true');
    setState(button, 'is-loading');
    announce(button, '');

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        /* /cart/add.js answers a rejection with a `status` and a description —
           most often the last one on the shelf went into someone else's cart
           between the page render and this click. */
        if (response.status) {
          setState(button, 'is-error');
          announce(button, response.description || response.message || window.cartStrings.error);
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'quick-add-card',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          reset(button);
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'quick-add-card',
          productVariantId: variantId,
          cartData: response,
        });

        // No drawer or notification to show it in — fall back to the cart page.
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        announce(button, window.cartStrings.itemAdded);
        setState(button, 'is-done');
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(response);
        reset(button);
      })
      .catch(function (error) {
        console.error(error);
        setState(button, 'is-error');
        announce(button, window.cartStrings.error);
        reset(button);
      });
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var button = event.target.closest('[data-quick-add]');
    if (!button) return;
    event.preventDefault();
    add(button);
  });
})();
